import React, { useContext } from "react";
import { LegacyCard as Card, BlockStack, InlineStack, Text } from "@shopify/polaris";
import baseHelper from "lib/helpers/base";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";

import { fullfillmentStatusProp } from "app/orders/modules/admin/features/view/propsType";

const FulfillmentStatus = (props) => {
  const { lineData, data } = props;
  const { userData, cms } = useContext(PrivateContext);
  const currentUserData = baseHelper.getResponseData(userData, constant.gql.GET_CURRENT_USER);

  const isTaxIncluded = !!data.taxesIncluded;
  const isSeller = baseHelper.isSeller(currentUserData);
  const totals = baseHelper.getOrderPrice(lineData, data, isSeller);
  const { isUpdatedOrderLine } = totals;
  const items = `${lineData.length > constant.value.ONE ? constant.items : `${cms("label.items")}:`} ${
    lineData.length
  } `;
  const markUpItems = `${totals.markUpItems > constant.value.ONE ? constant.items : `${cms("label.items")}:`} ${
    totals.markUpItems
  }`;
  const { code: discountLineCode = "" /* , amount */ } =
    (data.discountCodes && data.discountCodes.length && data.discountCodes[0]) || {};

  const getDynamicDiscount = (orderLineItem = {}) => {
    let discountValue = 0;
    (orderLineItem.discountAllocations || []).forEach((item) => {
      discountValue = item.amount;
    });
    return discountValue;
  };

  const dynamicDiscountValue = lineData.map((item) => getDynamicDiscount(item));
  let discountAmount = 0;
  const totalDynamicDiscount = dynamicDiscountValue.filter((item) => {
    discountAmount += parseFloat(item);
  });
  const moneyFormat = data.moneyFormat || constant.symbol.DOLLAR;
  const vendorsSum = [];
  lineData.filter(({ vendor }) => {
    vendorsSum.push(vendor);
    return vendorsSum;
  });
  const vendorSet = new Set(vendorsSum);
  const setSize = vendorSet.size;
  const addVendorTxt =
    setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;
  const lineDataItems = lineData.length;
  return (
    <div className="totalSection">
      <Card>
        <Card.Section subdued>
          <Card.Subsection>
            <Card.Section>
              <InlineStack wrap={false}>
                <Text as="h5">{cms("label.subTotal")}</Text>
                <Text as="span">{items}</Text>
                <Text as="span">
                  {`${moneyFormat}`}
                  {isUpdatedOrderLine ? baseHelper.getPrice(totals.price) : data.totalLineItemsPrice}
                </Text>
              </InlineStack>
            </Card.Section>
            <Card.Section>
              {isSeller && isUpdatedOrderLine && !!totals.markUp && (
                <InlineStack wrap={false}>
                  <Text as="h5">{cms("label.markUpTotal")}</Text>
                  <Text as="span">{markUpItems}</Text>
                  <Text as="span">
                    {`${moneyFormat}`}
                    {baseHelper.getPrice(totals.markUp)}
                  </Text>
                </InlineStack>
              )}
              <InlineStack wrap={false}>
                <Text as="h5">{cms("label.shipping")}</Text>
                <Text as="span">
                  {`${moneyFormat}`}
                  {baseHelper.getPrice(totals.shippingAmount)}
                </Text>
              </InlineStack>
            </Card.Section>
            <Card.Section>
              <InlineStack wrap={false}>
                <Text as="span">
                  {cms("label.discount")}
                  {discountLineCode ? `(${discountLineCode})` : ""}
                </Text>
                <Text as="span">
                  {`${moneyFormat}-`}
                  {baseHelper.getPrice(discountAmount) ||
                    (isUpdatedOrderLine &&
                      ((isSeller && baseHelper.getPrice(totals.sellerDiscount)) ||
                        baseHelper.getPrice(totals.discount))) ||
                    (lineData.totalDiscount && baseHelper.getPrice(lineData.totalDiscount)) ||
                    constant.value.FLOAT_ZERO}
                </Text>
              </InlineStack>
            </Card.Section>
            <Card.Section>
              <InlineStack wrap={false}>
                <Text as="span">
                  {cms("label.salesTax")}
                  {isTaxIncluded && ` ${cms("label.included")}`}
                </Text>
                <Text as="span">
                  {`${moneyFormat}`}
                  {!isSeller && isUpdatedOrderLine ? baseHelper.getPrice(totals.tax) : data.totalTax}
                </Text>
              </InlineStack>
            </Card.Section>
          </Card.Subsection>
        </Card.Section>
        <Card.Section>
          <BlockStack>
            <InlineStack wrap={false}>
              <b>{cms("label.total")}</b>
              <Text variant="bodySm" as="p">
                {" "}
                (
                {lineDataItems > 1
                  ? `${lineDataItems}
                ${cms("label.items")} from ${addVendorTxt}`
                  : `${lineDataItems}
                ${cms("label.item")} from ${addVendorTxt}`}
                )
              </Text>
              <b>
                {`${moneyFormat}`}
                {isUpdatedOrderLine ? baseHelper.getPrice(totals.totalPrice) : data.totalPrice}
              </b>
            </InlineStack>
          </BlockStack>
        </Card.Section>
      </Card>
    </div>
  );
};

FulfillmentStatus.propTypes = fullfillmentStatusProp.type;
export default FulfillmentStatus;
